import { Component } from '@angular/core';
import { FormFlow, FormFlowState, PgFormField, PgFormLayout } from '../../../models/form.model';
import { StepFormBase } from '../step-form-base';
import { DataService } from '../../../services/data.service';
import { EnvironmentService } from '../../../services/environment.service';
import { LocalizationService } from '../../../services/localization.service';
import { NotificationsService } from '../../../services/notifications.service';
import { OptionMapsService } from '../../../services/option-maps.service';
import { AuthService } from '../../../services/auth.service';
import { ConfigService } from '../../../services/config.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-forms-good',
    templateUrl: './forms-good.component.html',
    styleUrls: ['./forms-good.component.scss'],
    standalone: false
})
export class FormsGoodComponent extends StepFormBase {

    constructor(protected optionMapsService:OptionMapsService, protected localizationService:LocalizationService, protected dataService:DataService, protected authService:AuthService, protected router:Router, protected route:ActivatedRoute, protected environmentService:EnvironmentService, protected configService:ConfigService, protected notificationsService:NotificationsService) {
        super(optionMapsService, localizationService, dataService, authService, router, route, environmentService, configService, notificationsService);
    }

    formId = 'good';
    resourceId = 'Good';

    private _supplierOptions:Array<{ value:string, text: string, order?: number, category?: string }> = [];

    private _loadSupplierOptions() {
        return new Promise<null>((resolve) => {
            this._supplierOptions.splice(0);

            let _supplierResources = ['Host','Eatery','ExperienceSupplier'];
            let _reqNum = _supplierResources.length;

            for(let i = 0; i < _supplierResources.length; i++) {
                let _resource = _supplierResources[i];

                this.dataService.getResourceData(_resource, { limit: 1000 }, null, null, 'public').subscribe((dataPublished) => {
                    this.dataService.getResourceData(_resource, { limit: 1000, filter: [{ field: 'published', operator: '!=', value: [true] }] }).subscribe((dataUnpublished) => {
                        for(let _list of [dataPublished, dataUnpublished]) {
                            for(let _item of _list) {
                                let _text = _item.name;
                                if(!_item.published) {
                                    _text += '<small class="text-muted"> (' + this.localizationService.translate('forms-good.supplier-unpublished') + ')</small>'
                                }

                                this._supplierOptions.push({ value: _resource + '_' + _item.id, text: _text, order: i, category: this.localizationService.translateResource(_resource)  })
                            }
                        }

                        this._supplierOptions.sort((a, b) => {
                            if(a.order != b.order) {
                                if(a.order < b.order) return -1;
                                else if(a.order > b.order) return 1;
                            }
                            else {
                                let _aText = a.text.toLowerCase();
                                let _bText = b.text.toLowerCase();

                                if(_aText < _bText) return -1;
                                else if(_aText > _bText) return 1;
                                else return 0;
                            }
                        })

                        _reqNum--;
                        if(_reqNum <= 0) {
                            resolve(null)
                        }
                    }, () => {
                        _reqNum--;
                        if(_reqNum <= 0) {
                            resolve(null)
                        }
                    })
                })
            }
        })
    }

    initData() {
        return new Promise<null>((resolve) => {
            this._supplierOptions = [];

            if(this.viewOnly) {
                resolve(null)
            }
            else {
                this._loadSupplierOptions().then(() => {
                    resolve(null)
                })
            }
        })
    }

    createFormFlow() {
        let _cStates:{ [name:string]: FormFlowState } = {
            'dati_generali': {
                title: null,
                form: new PgFormLayout([
                    new PgFormField({ label: 'auto', type: 'select', multi: true, name: 'languages', tooltip: 'auto', required: true }),
                    new PgFormField({ label: null, type: 'split', name: 'split_0' }),
                    new PgFormField({ label: 'auto', type: 'string', name: 'name@GoodTranslation', required: true, locale: true, maxLength: 100 }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'supplier', options: this._supplierOptions, tooltip: 'auto', required: true }),
                    new PgFormField({ label: 'auto', type: 'info', name: 'images_rights', tooltip: 'auto' }),
                    new PgFormField({ label: 'auto', type: 'file', fileType: 'images', name: 'cover', tooltip: 'auto', required: true,
                        fileOptions: {
                            imageRatio: { width: 4, height: 3 }
                        }
                    }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'group_id' }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'realm_id' }),
                    new PgFormField({ label: 'auto', type: 'select', name: 'priority', default: 5, required: true }),
                ])
            },
            'descrizione': {
                title: null,
                form: new PgFormLayout([
                    new PgFormField({ label: 'auto', type: 'html', name: 'description@GoodTranslation', required: true, locale: true, tooltip: 'auto', maxLength: 5000 }),
                ])
            },
            'file': {
                title: null,
                description: 'auto',
                optional: true,
                form: new PgFormLayout([
                    new PgFormField({ label: 'auto', type: 'info', name: 'images_rights', tooltip: 'auto' }),
                    new PgFormField({ label: 'auto', type: 'file', multi: true, fileType: 'images', name: 'images',
                        fileOptions: {
                            imageRatio: { width: 4, height: 3 }
                        }
                    }),
                ])
            }
        }

        return new FormFlow(_cStates);
    }

    customizeFormFlow() {
        this.formFlow.states['dati_generali'].form.getFieldLayout('split_0').display = { invisible: true }
        this.formFlow.states['dati_generali'].form.getFieldLayout('supplier').display = { oneLine: true }
        this.formFlow.states['dati_generali'].form.getFieldByName('group_id').visible = false;
        this.formFlow.states['dati_generali'].form.getFieldByName('realm_id').visible = false;
        this.formFlow.states['dati_generali'].form.getFieldByName('priority').visible = false;
    }

    mapImportData(data:any) {
        return JSON.parse(JSON.stringify(data));
    }

    async afterInit() {
        if(this.viewOnly && this.importData?.supplier_type && this.importData?.supplier_id) {
            let _supplier = this.importData.supplier_type + '_' + this.importData.supplier_id;

            await new Promise<void>((resolve) => {
                this.dataService.getElementData(this.importData.supplier_type, this.importData.supplier_id).subscribe((data) => {
                    this._supplierOptions.push({ value: _supplier, text: data.id + ' - ' + data.name })
                    resolve()
                }, () => {
                    resolve()
                })
            })
        }
    }

    adaptLoadData(values:any) {
        values = super.adaptLoadData(values);

        if(values != null && values.supplier_type != null && values.supplier_id != null) {
            values.supplier = values.supplier_type + '_' + values.supplier_id;
        }

        return values;
    }

    adaptSaveData(values:any) {
        values = super.adaptSaveData(values);

        if(values != null && values.supplier != null) {
            let _separator = values.supplier.indexOf('_');
            if(_separator != -1) {
                values.supplier_type = values.supplier.substring(0, _separator);
                values.supplier_id = parseInt(values.supplier.substring(_separator + 1), 10);
            }
        }

        if(typeof values.supplier != 'undefined') {
            delete values.supplier;
        }

        return values;
    }
}
